// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  background-color: rgb(230, 230, 230);
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
} */

body, #root { height:100vh; }
.app-root-flex { display:flex; flex-direction:column; height:100%; }

/* Use viewport height so resizing is immediately visible */
.mainContainer {
  height:75vh; /* explicit: 75% of viewport height */
  display:flex;
  flex-direction:row;
  width:100%;
  overflow:hidden; /* prevent children from expanding height */
}

.arrayContainer {
  flex: 1;
  transition: margin 0.3s ease;
}

.top-meta-cluster {
  display: flex;
  justify-content: flex-end;
  padding: 0 24px;
}

.top-meta-inner {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}

.arrayContainer.withInfo {
  margin-left: 0;
}

/* Removed previous upward shift to restore toolbar interactivity */
`, "",{"version":3,"sources":["webpack://./src/components/Main.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,oCAAoC;EACpC,2BAA2B;EAC3B,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;GAYG;;AAEH,cAAc,YAAY,EAAE;AAC5B,iBAAiB,YAAY,EAAE,qBAAqB,EAAE,WAAW,EAAE;;AAEnE,2DAA2D;AAC3D;EACE,WAAW,EAAE,qCAAqC;EAClD,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,eAAe,EAAE,2CAA2C;AAC9D;;AAEA;EACE,OAAO;EACP,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA,mEAAmE","sourcesContent":["body {\n  margin: 0;\n  background-color: rgb(230, 230, 230);\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n/* body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n} */\n\nbody, #root { height:100vh; }\n.app-root-flex { display:flex; flex-direction:column; height:100%; }\n\n/* Use viewport height so resizing is immediately visible */\n.mainContainer {\n  height:75vh; /* explicit: 75% of viewport height */\n  display:flex;\n  flex-direction:row;\n  width:100%;\n  overflow:hidden; /* prevent children from expanding height */\n}\n\n.arrayContainer {\n  flex: 1;\n  transition: margin 0.3s ease;\n}\n\n.top-meta-cluster {\n  display: flex;\n  justify-content: flex-end;\n  padding: 0 24px;\n}\n\n.top-meta-inner {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 4px;\n}\n\n.arrayContainer.withInfo {\n  margin-left: 0;\n}\n\n/* Removed previous upward shift to restore toolbar interactivity */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
